/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ChecklistId202,
  DeleteApiV1ChecklistId401,
  DeleteApiV1ChecklistId404,
  DeleteApiV1ChecklistId500,
  DeleteApiV1ChecklistIdMutationResponse,
  DeleteApiV1ChecklistIdPathParams,
} from "../../types/checkListRegistroController/DeleteApiV1ChecklistId.ts";

export const deleteApiV1ChecklistIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ChecklistIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1ChecklistId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ChecklistId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ChecklistId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ChecklistId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistId500>;

export const deleteApiV1ChecklistIdMutationResponseSchema = z.lazy(
  () => deleteApiV1ChecklistId202Schema,
) as unknown as ToZod<DeleteApiV1ChecklistIdMutationResponse>;
